<template>
  <v-container
    fluid
    class="d-flex justify-center align-center"
    pa-md-4
    pa-2
    style="min-height: 10vh; border-radius: 0; overflow: auto"
  >
    <v-row class="d-flex justify-center">
      <v-col cols="12" sm="6" md="4" lg="10">
        <v-card rounded="0">
          <v-toolbar flat dense color="#005F95">
            <div>
              <!-- Small to Large Screens -->
              <h1
                class="Limit-Toolbar"
                :style="{
                  fontSize: isSmall ? '11px' : isMedium ? '16px' : '20px',
                }"
              >
                DINERS CLUB {{ product }} ONLINE APPLICATION
              </h1>
            </div>
          </v-toolbar>

          <v-form
            ref="LimitApproveForm"
            v-model="validLimitApproved"
            lazy-validation
          >
            <v-container
              fluid
              style="border: 1px solid #ccc; border-radius: 0; padding: 16px"
            >
              <v-container fluid style="border-radius: 0; padding: 16px">
                <v-row>
                  <v-col cols="12" sm="12">
                    <h1 style="text-align: left" class="Credit-Limit-Approve">
                      CREDIT LIMIT APPROVED IN PRINCIPLE
                    </h1>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col sm="12">
                    <h2 style="text-align: left" class="Credit-Limit">
                      CREDIT LIMIT
                    </h2>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="12">
                    <p class="Welcome-to-Diners" style="text-align: left">
                      Welcome to Diners Club. Your application has been approved
                      in principle.<br />
                      You qualify for a maximum credit of
                      <b>R {{ grantedCreditLimit }}</b> subject to verification
                      in accordance with relevant Diners Club policies and
                      procedures.<br />
                      For a reduced limit please enter the value below:
                    </p>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="3" v-if="noMatch || isXlarge">
                    <v-text-field
                      v-model="txtReducedlimit"
                      :rules="[rules.numberfield.regex]"
                      label="Reduced Limit"
                      mask="###############"
                      required
                      readonly
                      prefix="R"
                      color="#005F95"
                      variant="underlined"
                      density="comfortable"
                      prepend-icon="mdi-credit-card-check"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="2">
                    <v-card-text>
                      <v-slider
                        v-model="txtReducedlimit"
                        :step="500"
                        class="align-center"
                        :min="min"
                        :max="max"
                        hide-details
                        tick-size="5"
                        thumb-size="15"
                        thumb-label="always"
                        color="#005F95"
                      />
                      <p>Reduce Limit</p>
                    </v-card-text>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="10" class="text-left">
                    <p class="Welcome-to-Diners">
                      <b>Disclaimer:</b> Kindly note that this quote does not
                      represent an express or implied offer of funding, nor does
                      it create any liability or obligation on Diners Club S.A.
                      to provide such funding. We give no warranty, express or
                      implied, as to the accuracy, reliability, or completeness
                      of any information, formula, or calculation provided
                      through the use of the online quote functionality, and we
                      will not be liable for any loss or damage that may be
                      attributable to reliance on and use of the online quote
                      functionality.
                    </p>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col sm="12">
                        <h2 style="text-align: left" class="Credit-Limit">
                          WHAT ARE YOU USING THESE FUNDS FOR?
                        </h2>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="10">
                    <v-radio-group
                      v-model="radioUseOfFunds"
                      :rules="[
                        (v) => !!v || 'At least one field must be selected!',
                      ]"
                      row
                      required
                    >
                      <v-row>
                        <v-col cols="12" sm="2">
                          <v-radio
                            label="Housing"
                            value="housing"
                            color="#005F95"
                          ></v-radio>
                        </v-col>
                        <v-col cols="12" sm="3">
                          <v-radio
                            label="Emergency loan"
                            value="emergency"
                            color="#005F95"
                          ></v-radio>
                        </v-col>
                        <v-col cols="12" sm="2">
                          <v-radio
                            label="Education"
                            value="education"
                            color="#005F95"
                          ></v-radio>
                        </v-col>
                        <v-col cols="12" sm="3">
                          <v-radio
                            label="Pay off debts"
                            value="paydebts"
                            color="#005F95"
                          ></v-radio>
                        </v-col>
                        <v-col cols="12" sm="2">
                          <v-radio
                            label="Other"
                            value="otheruse"
                            color="#005F95"
                          ></v-radio>
                        </v-col>
                      </v-row>
                    </v-radio-group>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="6" style="text-align: left">
                    <v-btn
                      color="#005F95"
                      class="text-white"
                      to="/SingleQuote"
                      style="border-radius: 0; width: 170px; height: 30px"
                    >
                      PREVIOUS
                    </v-btn>
                  </v-col>

                  <v-col cols="6" style="text-align: right">
                    <v-btn
                      color="#005F95"
                      class="text-white"
                      style="border-radius: 0; width: 170px; height: 30px"
                      @click="startApplication"
                      :loading="isLoading"
                      :disabled="!isApprovedLimitFormValid"
                    >
                      <span v-if="!isLoading">START NEW APP</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-container>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
/* eslint-disable */
import { useDisplay } from "vuetify/lib/framework.mjs";
import { ref, onBeforeMount, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import axios from "axios"; // Import axios if not globally available

const { smAndDown, mdAndUp, lgAndUp } = useDisplay();
const isSmall = smAndDown;
const isMedium = computed(() => mdAndUp.value && !lgAndUp.value);
// const isLarge = lgAndUp;

const { xs, xl } = useDisplay();

const rules = {
  numberfield: {
    regex: (v) => /^[0-9]*$/.test(v) || "Only numbers allowed",
  },
};

const noMatch = computed(() => !xs.value && !xl.value);
const isXlarge = computed(() => xl.value);
const txtReducedlimit = ref("");
const min = ref(1000); // Adjust as needed (Put in a "reducedCreditLimit" Function!!!!)
const max = ref(""); // Adjust as needed (Put in a "reducedCreditLimit" Function!!!!)
const radioUseOfFunds = ref("");
const grantedlimit = ref(""); // Define if needed
const isCreditDetailsComplete = ref(true); // Example value
const router = useRouter();
const appStatus = ref("");
const BeyondSelected = ref(false);
const isLoading = ref(false);
const product = ref("");
const prodtype = ref("");
const refNumber = ref("");
const apptype = ref("");
const validLimitApproved = ref("");

const startApplication = () => {
  // isLoading.value = true;
  updateCreditDetails();
};

//Form Field Validations - OTP Form
const isApprovedLimitFormValid = computed(() => {
  return (
    max.value !== "" &&
    txtReducedlimit.value !== "" &&
    radioUseOfFunds.value !== ""
  );
});

onBeforeMount(() => {
  prodtype.value = sessionStorage.getItem("prodtype");
  apptype.value = sessionStorage.getItem("apptype");
  appStatus.value = sessionStorage.getItem("appStatus");

  if (apptype.value === "newapp") {
    refNumber.value = sessionStorage.getItem("refNumber");
  } else if (apptype.value === "continueapp") {
    refNumber.value = sessionStorage.getItem("incompleteRef");
  }

  // Redirect if application status is Declined, Approved, or Referred
  if (["Declined", "Approved", "Referred"].includes(appStatus.value)) {
    router.push("/");
    return;
  }

  // Set product type
  if (prodtype.value === "platinum") {
    product.value = "CREDIT CARD";
  } else if (prodtype.value === "shariah") {
    product.value = "SHARI'AH CARD";
  } else {
    product.value = "BEYOND CARD";
    BeyondSelected.value = true;
  }

  if (apptype.value === "newapp" && refNumber.value !== null) {
    reducedCreditLimit();
    // GetUserForReferenceNumber();
  } else if (apptype.value === "continueapp" && refNumber.value !== null) {
    if (
      ["Referred", "Approved", "Declined", "Pending"].includes(appStatus.value)
    ) {
      router.push("/ApplicationList");
    } else if (
      apptype.value === "continueapp" &&
      appStatus.value === "Incomplete"
    ) {
      reducedCreditLimit();
      // getGTSValueData();
      // GetUserForReferenceNumber();

      if (sessionStorage.getItem("IDType") === "Passport") {
        e1.value = 6;
      }
    }
  } else {
    router.push("/");
  }
});

const grantedCreditLimit = computed(
  () => sessionStorage.getItem("grantedCreditLimit") || "0"
);

const reducedCreditLimit = () => {
  txtReducedlimit.value = sessionStorage.getItem("grantedCreditLimit") || "";
  max.value = sessionStorage.getItem("grantedCreditLimit") || 0;
  min.value = 1000;
};

const updateCreditDetails = async () => {
  const token = sessionStorage.getItem("authToken");

  isLoading.value = true;

  sessionStorage.setItem("limitaccepted", txtReducedlimit.value.toString());

  if (!refNumber.value && !token) {
    console.log("User not Authorized");
    isLoading.value = false;
    return;
  } else {
    try {
      const response = await axios.post(
        "/updateCreditDetails",
        {
          REFNUMBER: refNumber.value,
          REDUCEDLIMIT: txtReducedlimit.value.toString(),
          USEOFFUNDS: radioUseOfFunds.value,
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );

      if (response.status !== 200) {
        isLoading.value = false;
        router.push("/TechnicalError");
      } else {
        isLoading.value = false;

        if (["UPDATED", "ADDED"].includes(response.data.data.RESPONSE)) {
          router.push("/NewApp");
        }
      }
    } catch (error) {
      console.error(error);
      isLoading.value = false;
    }
  }
};
</script>

<style>
#heading {
  padding: 3%;
}

.container-content-alignment {
  padding: 50px;
}

.my-card {
  border: 5px solid white; /* Change color and thickness */
  border-radius: 0px; /* Optional: Add rounded corners */
}

#insidecard {
  text-align: left;
  border: 5px solid white; /* Change color and thickness */
  border-radius: 0px; /* Optional: Add rounded corners */
  margin-bottom: 7%;
}

@font-face {
  font-family: "GathamLight";
  src: url("@/assets/fonts/Gotham-Light.woff2") format("woff2"),
    url("@/assets/fonts/Gotham-Light.otf") format("opentype");
  font-display: swap;
}
.Credit-Limit-Approve {
  font-family: "GathamLight";
  font-size: 28px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #041e42;
}
@font-face {
  font-family: "GathamMedium";
  src: url("@/assets/fonts/Gotham-Medium.woff2") format("woff2"),
    url("@/assets/fonts/Gotham-Medium.otf") format("opentype");
  font-display: swap;
}
.Credit-Limit {
  font-family: "GathamMedium";
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #041e42;
}

.Welcome-to-Diners {
  font-family: "GathamLight";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #041e42;
}

p {
  font-family: "GathamLight";
  font-size: 14px;
  text-align: left;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #041e42;
}

@font-face {
  font-family: "GathamBookLimit";
  src: url("../assets/fonts/Gotham-Book.otf");
}
.Limit-Toolbar {
  font-family: "GathamBookLimit";
  /* font-size: 30px; */
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #fff;
  padding: 16px;
}

label {
  font-family: "GathamLight";
  color: #041e42;
}
h1 {
  font-family: "GathamLight";
  color: #041e42;
}
h2 {
  font-family: "GathamLight";
  color: #041e42;
}
h3 {
  font-family: "GathamLight";
  color: #041e42;
}
</style>
